import * as React from 'react';
import { Box, Typography, SxProps, Theme } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';

interface AIErrorBubbleProps {
    text: string;
    sx?: SxProps<Theme>;
}

export default function AIErrorBubble({
  text,
  sx,
}: Readonly<AIErrorBubbleProps>) {
    const theme = useTheme();
    const bg = alpha(theme.palette.error.main, 0.12);

    return (
        <Box
            sx={{
                alignSelf: 'flex-start',
                display: 'flex',
                alignItems: 'flex-start',
                gap: 1.5,
                maxWidth: { xs: '90%', md: '70%' },
                backgroundColor: bg,
                color: theme.palette.error.main,
                borderRadius: '16px',
                p: 2,
                boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                position: 'relative',
                ...sx,
            }}
        >
            <Box
                aria-hidden
                sx={{
                    minWidth: 22,
                    height: 22,
                    borderRadius: '50%',
                    backgroundColor: theme.palette.error.main,
                    color: theme.palette.common.white,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    fontSize: 14,
                    lineHeight: 1,
                    mt: '2px',
                    mr: '4px',
                }}
            >
                !
            </Box>

            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {text}
            </Typography>
        </Box>
    );
};
